module.exports = "/_next/static/images/a538e24dbbc83ad265a650f9a630852e-perks-xs-2x.jpg";